// extracted by mini-css-extract-plugin
export default {"root":"LoginFormContainer__root--Jfs8t6","forgotLink":"LoginFormContainer__forgotLink--vYHyhW"};